import { Link } from "react-router-dom";
import { useI18n } from "@/i18n/I18nProvider";

export default function NotFoundPage() {
  const { t } = useI18n();
  return (
    <section
      data-testid="not-found"
      className="min-h-[70vh] bg-brand-off flex items-center"
    >
      <div className="container-x text-center">
        <p className="eyebrow mb-5">{t("notFound.eyebrow")}</p>
        <h1 className="text-4xl md:text-6xl font-light tracking-tight text-brand-charcoal">
          {t("notFound.title")}
        </h1>
        <p className="mt-4 text-brand-muted max-w-md mx-auto">{t("notFound.description")}</p>
        <Link
          to="/"
          data-testid="not-found-home"
          className="mt-8 inline-flex items-center gap-2 rounded-full bg-brand-charcoal text-brand-off px-5 py-3 text-[14px] font-medium hover:bg-brand-dark transition-colors"
        >
          {t("notFound.cta")}
        </Link>
      </div>
    </section>
  );
}
